import { useMutation } from "@apollo/client";
import { LOGS_GIVE_FEEDBACK } from "@repo-sapiens/graphql";
import { ButtonWithGradient, Dialog, Text } from "../../../components";
import React, { useState } from "react";
import { T_AssistantActionsDocument } from "@repo-sapiens/data-access-models";
import {
  DialogContentStyle,
  ExplainerTextStyle,
  FlagReviewBtnStyle,
  TextAreaStyle,
} from "../styles";
import { ActivityItem } from "./activityItem";

type Props = {
  item?: T_AssistantActionsDocument;
  open?: boolean;
  onOpenChange?(open: boolean): void;
};
export const ActivityDetailsDialog: React.FC<Props> = ({
  item,
  open,
  onOpenChange,
}) => {
  const [toFlag, setToFlag] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [flagged, setFlagged] = useState(false);

  const [giveFeedback] = useMutation(LOGS_GIVE_FEEDBACK);

  const handleFeedback = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setFeedback(e.target.value);
  };

  const handleFlag = () => {
    setToFlag(true);
  };

  const onChange = (val: boolean) => {
    onOpenChange?.(val);
    setToFlag(false);
    setFlagged(false);
  };

  const handleSendReport = () => {
    setFlagged(true);

    setTimeout(() => {
      onChange(false);
    }, 3000);

    // send feedback to backend
    if (item && feedback) {
      giveFeedback({
        variables: {
          id: item._id,
          feedback,
        },
      }).then(() => {
        // do nothing
      });
    }
  };

  return (
    <Dialog
      noClose
      additionalContent={
        <div className={DialogContentStyle}>
          {item && <ActivityItem item={item} inspecting />}

          <Text.Body2XS color="seconday">Explanation</Text.Body2XS>
          <div
            className={ExplainerTextStyle}
            dangerouslySetInnerHTML={{
              __html: item?.reason?.split("\n").join("<br>") || "",
            }}
          />

          {toFlag && !flagged && (
            <textarea
              className={TextAreaStyle}
              placeholder="Let us know what went wrong"
              autoFocus
              value={feedback}
              onChange={handleFeedback}
            ></textarea>
          )}

          {toFlag && !flagged && (
            <Text.Body2XS color="seconday">
              *By filling this form out, you agree Multiplayer will have access
              to and the ability to read this service for the purposes of
              improving the service we deliver to you. We will not train the
              model off of your data or access beyond what we need to address
              your feedback
            </Text.Body2XS>
          )}

          {flagged && (
            <Text.Body color="primary" marginTop={18}>
              Thank you for your feedback. We will review this and get back to
              you soon.
            </Text.Body>
          )}

          <div className={FlagReviewBtnStyle}>
            {item?.serviceName === "email"}
            <Text.Link
              size="body-sm"
              href={`https://mail.google.com/mail/u/0/#inbox/${item?.service}`}
              target="_blank"
              rel="noreferrer"
              style={{ marginBottom: 16 }}
            >
              Go to the email
            </Text.Link>

            {!toFlag && (
              <ButtonWithGradient onClick={handleFlag}>
                Flag for human review
              </ButtonWithGradient>
            )}

            {toFlag && !flagged && (
              <ButtonWithGradient onClick={handleSendReport}>
                Send report
              </ButtonWithGradient>
            )}
          </div>
        </div>
      }
      open={open}
      onOpenChange={onChange}
    />
  );
};
